import type { FC } from 'react';

import { FaceSmileIcon, LinkIcon, PhotoIcon } from '@heroicons/react/24/outline';

import { ICON_CLASS, tr } from '../constants';
import { TextTIcon } from './icons';
import { ToolbarButton } from './ToolbarButton';

interface DisabledToolbarProps {
  translations?: Record<string, string>;
  showMedia?: boolean;
}

export const DisabledToolbar: FC<DisabledToolbarProps> = ({ translations, showMedia = true }) => {
  return (
    <div className="flex gap-2 items-center">
      <ToolbarButton label={tr(translations, 'community.composer.format_text')} icon={<TextTIcon />} disabled />
      <ToolbarButton
        label={tr(translations, 'community.composer.add_emoji')}
        icon={<FaceSmileIcon className={ICON_CLASS} aria-hidden="true" />}
        disabled
      />
      {showMedia && (
        <ToolbarButton
          label={tr(translations, 'community.composer.add_media')}
          icon={<PhotoIcon className={ICON_CLASS} aria-hidden="true" />}
          disabled
        />
      )}
      <ToolbarButton
        label={tr(translations, 'community.composer.add_link')}
        icon={<LinkIcon className={ICON_CLASS} aria-hidden="true" />}
        disabled
      />
    </div>
  );
};
